'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const LogoDecathlonCoreSymbolBrandAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.0497 2.28882e-06C11.6688 2.28882e-06 0 9.70597 0 17.7501C0 21.9047 3.19116 24 7.40593 24C10.5007 24 14.2459 22.868 17.8585 20.6884V4.63623C16.8951 6.286 12.3673 12.9333 8.73056 16.4737C6.87606 18.28 5.40691 19.0627 4.14249 19.0627C2.72152 19.0627 2.04716 18.0993 2.04716 16.6663C2.04716 10.1636 12.9935 1.70999 20.2429 1.70999C23.2293 1.70999 25.156 3.03462 25.156 5.61164C25.156 7.9719 23.5544 10.9343 20.8209 13.6678V18.6412C25.5896 14.8721 28.4435 10.0672 28.4435 6.18966C28.4435 2.10737 25.2644 2.28882e-06 21.0497 2.28882e-06Z",
        fill: "#3643BA"
      }
    )
  }
);
const VpLogoDecathlonCoreSymbolBrandAsset = forwardRef(LogoDecathlonCoreSymbolBrandAsset);

export { VpLogoDecathlonCoreSymbolBrandAsset as default };
